import React, { useState } from 'react'; 
import { Button, Modal, List } from 'antd';  
import useHasError from '../../hooks/useHasError'; 
import useIsLoading from '../../hooks/useIsLoading'; 
import AIReportView from '../../components/AIReportView/AIReportView';
import SpinnerCentered from '../../components/SpinnerCentered/SpinnerCentered';
import useAIListPromptReports from '../../gql/hooks/useAIListPromptReports';
import './styles.less';
 
const AIReportsList = ( { promptId, header } ) => { 
    const { reports, reportsLoading, reportsError } = useAIListPromptReports( promptId );
    const { isLoading } = useIsLoading( { items: [ reportsLoading ] } );
    const { hasError } = useHasError( { items: [ reportsError ] } );
    const [ showModal, setShowModal ] = useState( false );
    const [ reportId, setReportId ] = useState();
    const [ reportData, setReportData ] = useState();

    /*************************************
     *  ANCHOR Event Handlers
     *************************************/

    const handleViewClick = ( item ) => { 
        setReportData( item );
        setReportId( item.id );
        setShowModal( true );
    };

    const handleCloseModal = ( ) => { 
        setShowModal( false );
        setReportId( undefined );
        setReportData( undefined );
    };

    /*************************************
     *  ANCHOR Render
     *************************************/
     
    return ( 
        <div className="ai-reports-view">
            
            { /* Loading spinner */ }
            { isLoading &&
                <SpinnerCentered/>
            }

            { /* Reports list */ }
            { !isLoading && !hasError &&
                <>
                    <List 
                        size="small" 
                        header={ header }
                        dataSource={ reports }
                        locale={ { emptyText: 'No reports' } }
                        renderItem={ i => 
                            <List.Item
                                key={ i.id }
                                extra= {
                                    <Button 
                                        type="link"
                                        onClick = { () => handleViewClick( i ) }
                                    >
                                        View Report
                                    </Button>
                                }
                            > 
                                { i.createdAt }
                            </List.Item>
                        }
                    />

                    { reportId && promptId && showModal && 
                        <Modal
                            title={ reportData.createdAt }
                            centered
                            open={ showModal }
                            onOk={ handleCloseModal }
                            onCancel={ handleCloseModal }
                            cancelButtonProps={ { hidden: true } }
                            width={ 1000 }
                            wrapClassName="ai-report-modal"
                        >
                            <AIReportView reportId={ reportId } promptId={ promptId }/>
                        </Modal>
                    }
                </>
            }
        </div>
    );
};

export default AIReportsList;
